import styled from 'styled-components';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { breakpoints } from 'stylesheet';

export const Styles = {
  Container: styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    @media (min-width: ${breakpoints.small}) {
      flex-grow: 1;
      align-items: center;
    }
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;

    text-align: center;
    max-width: 280px;
    align-items: center;
    @media (min-width: ${breakpoints.small}) {
      position: relative;
      top: ${defaultTheme.spacing(-30)}; // centres div to screen
    }
  `,
  SearchIconContainer: styled.div`
    background-color: ${defaultTheme.colors.whiteSmoke};
    display: flex;
    border-radius: 100%;
    justify-content: center;
    align-items: center;
    height: 80px;
    width: 80px;
    margin-bottom: ${defaultTheme.spacing(5)};
  `,
  HeadingContainer: styled.div`
    margin-bottom: ${defaultTheme.spacing(2)};
  `,
};
